<div  class="braintree-payment">
    <div class="payment-secure-box">
        <div class="payment-card-wrap" *ngIf="cardDetails">
            <form action="" [formGroup]="cardDetails">
                <div class="row">
                    <div class="obf-fs-input-wrap col-lg-8 col-12 order-lg-1">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>
                                {{ paymentsConfig?.form_inputs?.card_number?.label }}
                            </serviceos-ng-label>
                                <input
                                    [serviceosNgInput]="cardNumber?.value"
                                    serviceosWebInputFormatter
                                    [fieldType]="'cardNumber'"
                                    type="text"
                                    id="cardNumber"
                                    tabindex="1"
                                    name="cardNumber"
                                    [error]="(cardDetails?.errors?.cardNumber || cardDetails?.errors?.notSupportedCard || cardNumber?.invalid) && formSubmit"
                                    formControlName="cardNumber" />
                            <serviceos-ng-error-message>
                                {{ cardNumber?.invalid ? paymentsConfig?.form_inputs?.card_number?.required_error : paymentsConfig?.form_inputs?.card_number?.validation_error }}
                            </serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>

                    <div class="obf-fs-input-wrap col-lg-8 col-12 order-lg-3">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>
                                {{ paymentsConfig?.form_inputs?.name_on_card?.label }}
                            </serviceos-ng-label>
                                <input
                                    [serviceosNgInput]="nameOnCard?.value"
                                    type="text"
                                    id="nameOnCard"
                                    tabindex="3"
                                    name="nameOnCard"
                                    [error]="nameOnCard?.invalid && formSubmit"
                                    formControlName="nameOnCard" />
                            <serviceos-ng-error-message>{{ paymentsConfig?.form_inputs?.name_on_card?.required_error }}</serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>

                    <div class="obf-fs-input-wrap col-lg-4 col-12 order-lg-2">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>
                                {{ paymentsConfig?.form_inputs?.expiry_date?.label }}
                            </serviceos-ng-label>
                                <input
                                    [serviceosNgInput]="expiry?.value"
                                    serviceosWebInputFormatter
                                    [fieldType]="'expiry'"
                                    type="text"
                                    id="expiry"
                                    tabindex="2"
                                    name="expiry"
                                    [errorMessage]=""
                                    [error]="(cardDetails?.errors?.cardExpiry || expiry?.invalid) && formSubmit"
                                    formControlName="expiry" />
                            <serviceos-ng-error-message>
                                {{ expiry?.invalid ? paymentsConfig?.form_inputs?.expiry_date?.required_error : paymentsConfig?.form_inputs?.expiry_date?.validation_error }}
                            </serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>
                    
                    <div class="obf-fs-input-wrap col-lg-4 col-12 order-lg-4">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>
                                {{ paymentsConfig?.form_inputs?.cvv?.label }}
                            </serviceos-ng-label>
                                <input
                                    [serviceosNgInput]="cvv?.value"
                                    serviceosWebInputFormatter
                                    [fieldType]="'cvv'"
                                    type="text"
                                    id="cvv"
                                    tabindex="4"
                                    name="cvv"
                                    [errorMessage]=""
                                    [error]="(cardDetails?.errors?.cardCvv || cvv?.invalid) && formSubmit"
                                    formControlName="cvv" />
                            <serviceos-ng-error-message>
                                {{ cvv?.invalid ? paymentsConfig?.form_inputs?.cvv?.required_error : paymentsConfig?.form_inputs?.cvv?.validation_error }}
                            </serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
